module.exports = __webpack_public_path__ + "static/media/polytope_5_3_52_vertex_explode.0758ed46.gif";